"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegalFormRef = void 0;
const Field_type_1 = require("../../types/Field.type");
exports.LegalFormRef = {
    priority: Number.MAX_VALUE,
    label: 'fields.enm.legal_form.label',
    fallbackLabel: 'Legal entity Type',
    type: Field_type_1.FieldType.Enum,
    options: [
        { key: 'SOLE_TRADER', label: 'fields.enm.legal_form.options.SOLE_TRADER', fallbackLabel: 'Sole trader' },
        { key: 'PARTNERSHIP', label: 'fields.enm.legal_form.options.PARTNERSHIP', fallbackLabel: 'Partnership' },
        { key: 'LIMITED_LIABILITY_COMPANY', label: 'fields.enm.legal_form.options.LIMITED_LIABILITY_COMPANY', fallbackLabel: 'Limited liability company' },
        { key: 'PUBLIC_LIMITED_COMPANY', label: 'fields.enm.legal_form.options.PUBLIC_LIMITED_COMPANY', fallbackLabel: 'Public limited company' },
        { key: 'STATE_OWNED_COMPANY', label: 'fields.enm.legal_form.options.STATE_OWNED_COMPANY', fallbackLabel: 'State owned company' },
        { key: 'PRIVATE_UNLIMITED_COMPANY', label: 'fields.enm.legal_form.options.PRIVATE_UNLIMITED_COMPANY', fallbackLabel: 'Private unlimited company' },
        { key: 'ASSOCIATION', label: 'fields.enm.legal_form.options.ASSOCIATION', fallbackLabel: 'Association' },
        { key: 'COOPERATIVE', label: 'fields.enm.legal_form.options.COOPERATIVE', fallbackLabel: 'Co-operative' },
        { key: 'FOUNDATION', label: 'fields.enm.legal_form.options.FOUNDATION', fallbackLabel: 'Foundation' },
        { key: 'TRUST', label: 'fields.enm.legal_form.options.TRUST', fallbackLabel: 'Trust' },
        { key: 'NON_PROFIT_ORGANISATION', label: 'fields.enm.legal_form.options.NON_PROFIT_ORGANISATION', fallbackLabel: 'Non-profit organisation' },
    ],
    trackFieldValueWithAnalytics: false,
};
